/**
 * Global scope controls in the app header. Renders the locality and/or time-range
 * selectors only for the route the user is on, per that route's `scope` declaration
 * in the feature registry (aggregate pages opt in; detail/utility pages opt out).
 */
import { useLocation } from "react-router-dom";

import { DayRangeSelect } from "@/components/DayRangeSelect";
import { useAuth } from "@/auth/AuthContext";
import { activeScope } from "@/features/registry";
import { LocalitySelect } from "@/scope/LocalitySelect";
import { useScope } from "@/scope/ScopeContext";

export function ScopeBar() {
  const { pathname } = useLocation();
  const { features, user } = useAuth();
  const { locality, days, setLocality, setDays } = useScope();

  const scope = activeScope(pathname, features, user);
  if (!scope || (!scope.locality && !scope.days)) return null;

  return (
    <div className="flex items-center gap-3">
      {scope.locality && <LocalitySelect value={locality} onChange={setLocality} />}
      {scope.days && <DayRangeSelect value={days} onChange={setDays} />}
    </div>
  );
}
